import { UPDATE_ADD_TO_CART, UPDATE_MESSAGE } from './types';


export const forgotPasswordMsgAction = (message) => dispatch => {
     dispatch({
        type: UPDATE_MESSAGE,
        message: message,
    })

}
